import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

const FORMATS = {
  full: 'EE, MMMM d, y h:mm a zzzz',
  short: 'MMM d, y  HH:mm a O',
  dayAndTime: 'EEEE HH:mm',
  shortDate: 'MMM d, y',
  time: 'HH:mm a O',
  shortTime: 'HH:mm'
};

@Pipe({ name: 'htmlDocType' })
export class HtmlDocTypePipe implements PipeTransform {
  constructor( @Inject(LOCALE_ID) private locale: string,
               private translate: TranslateService) {
  }

  transform(value: string): string {
    return this.translate.instant('document.type.' + value);
  }
}
